import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot } from '@angular/router';
import { OtpService } from '../../services/otp/otp.service';
import { AuthService } from '../../services/auth/auth.service';
import { ROUTE_PATHS } from '../../utils/route-paths.const';

/**
 * Auth Data Guard
 * Handles authentication data checks based on route data:
 * 1. Phone Verification - Always checks phone number exists
 * 2. Investor Type (requireInvestorType: true) - Checks investor type selection
 *
 * Usage in routes:
 * - For phone-only check: no data needed
 * - For investor type check: data: { requireInvestorType: true }
 */
export const authDataGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const otpService = inject(OtpService);
  const authService = inject(AuthService);
  const router = inject(Router);

  const requireInvestorType = route.data['requireInvestorType'] ?? false;

  // Always check phone number
  const phoneNumber = otpService.getPhoneNumber();
  if (!phoneNumber) {
    router.navigate([ROUTE_PATHS.AUTH, ROUTE_PATHS.PHONE_VERIFICATION], {
      replaceUrl: true,
    });
    return false;
  }

  // Check investor type if required
  if (requireInvestorType) {
    const investorType = authService.getInvestorType();
    if (!investorType) {
      router.navigate([ROUTE_PATHS.AUTH, ROUTE_PATHS.INVESTOR_TYPE], {
        replaceUrl: true,
      });
      return false;
    }
  }

  return true;
};
